import { Check, CheckCheck, CircleAlert, Clock } from "lucide-react";

import type { MessageDeliveryStatus } from "@mandoob/shared";

import { cn } from "@/lib/utils";

/**
 * WhatsApp-style delivery indicator for an outbound message: a clock while
 * pending, a red alert on failure, one gray tick when sent, double ticks when
 * delivered (turning brand-colored once read). Renders nothing when no
 * delivery state applies (e.g. inbound messages). Ported from the reference
 * delivery-ticks.tsx onto our MessageDeliveryStatus enum.
 */
export function DeliveryTicks({
  delivery,
}: {
  delivery?: MessageDeliveryStatus | null;
}) {
  if (!delivery) return null;
  if (delivery === "Pending") {
    return (
      <Clock
        className="tw:size-3.5 tw:shrink-0 tw:text-muted-foreground"
        strokeWidth={2.3}
      />
    );
  }
  if (delivery === "Failed") {
    return (
      <CircleAlert
        className="tw:size-4 tw:shrink-0 tw:text-destructive"
        strokeWidth={2}
      />
    );
  }
  if (delivery === "Sent") {
    return (
      <Check
        className="tw:size-4 tw:shrink-0 tw:text-muted-foreground"
        strokeWidth={2.3}
      />
    );
  }
  return (
    <CheckCheck
      className={cn(
        "tw:size-4 tw:shrink-0",
        // Official WhatsApp read-tick blue (same tone the reference uses).
        delivery === "Read" ? "tw:text-[#007BFC]" : "tw:text-muted-foreground",
      )}
      strokeWidth={2.3}
    />
  );
}
